import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.isUserPracticeDemo()) {
                return next()
            }
            next({
                name: 'auth.login',
                query: { redirect: to.fullPath !== '/' ? to.fullPath : undefined },
            })
        })
    },
}
